<script>
  import Router from 'svelte-spa-router';
  import { map, mapValues, keyBy } from 'lodash-es';

  import Header from './components/Header.svelte';
  import Wrapper from './components/Wrapper.svelte';
  import Tabbar from './components/Tabbar.svelte';
  import TooltipView from './components/TooltipView.svelte';

  import Issues from './routes/Issues.svelte';
  // import IssuesSvg from './routes/IssuesSvg.svelte';
  import Departments from './routes/Departments.svelte';
  import Words from './routes/Words.svelte';

  import { isReady } from './data/dataAPI';

  const routes = [
    { slug: '/', name: 'Ausgaben', component: Issues },
    // { slug: '/export', name: 'Ausgaben (Export)', component: IssuesSvg },
    { slug: '/ressorts', name: 'Ressorts', component: Departments },
    { slug: '/woerter', name: 'Wörter', component: Words },
  ];
  const tabbarOptions = map(routes, d => ({
    slug: d.slug,
    name: d.name,
  }));
  const routerRoutes = mapValues(keyBy(routes, 'slug'), 'component');
</script>

<style lang="scss" global>
  @import './styles/reset.scss';
  @import './styles/base.scss';
  .app {
    margin-bottom: 30px;
  }
</style>

<div class="app">
  <Wrapper>
    <Header />
    <Tabbar options={tabbarOptions} />
    {#if $isReady}
      <main>
        <Router routes={routerRoutes} />
      </main>
      <TooltipView />
    {:else}
      <p>Loading...</p>
    {/if}
  </Wrapper>
</div>
